var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"list"},_vm._l((_vm.list),function(item){return _c('CardItem',{key:item.id,attrs:{"info":item}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }